module.exports = __webpack_public_path__ + "static/media/bg-take-prize-thadingyut-2025-theme.d213e157.png";